import { css, type Interpolation, type Theme } from '@emotion/react'
import { CSSProperties, memo, useState } from 'react'
import { PAPER_HEIGHTS } from '../../../theme'
import CircularProgress from '../../CircularProgress'
import Loading from '../../Loading'

const iframeRootStyles = css({
    flexDirection: 'column' as const,
    position: 'relative' as const,
    overflow: 'hidden',
    background: '#fff',
    display: 'flex',
    height: '100%',
    width: '100%',
})

const containerStyles = css({
    overflowX: 'hidden' as const,
    overflowY: 'auto' as const,
    display: 'flex',
    height: '100%',
    flexShrink: 0,
    width: '100%',
    zIndex: PAPER_HEIGHTS.base,
})

const iframeStyles = css({
    flexShrink: 0,
    height: '100%',
    width: '100%',
    padding: 0,
    border: 0,
    flex: 1,
})

interface IFrameProps {
    allowFullScreen?: boolean
    disableScrolling?: boolean
    src: string
    style?: CSSProperties
    styleOverrides?: Interpolation<Theme>
    className?: string
    iFrameClassName?: string
}

const IFrame = memo<IFrameProps>((props) => {
    const {
        allowFullScreen,
        disableScrolling,
        style = {},
        src,
        styleOverrides,
    } = props
    const [loading, setLoading] = useState(true)
    return (
        <div
            css={[iframeRootStyles, styleOverrides]}
            data-testid="iFrame__Root"
        >
            {loading && (
                <Loading style={{ color: '#000' }}>
                    <CircularProgress />
                </Loading>
            )}
            <div css={containerStyles}>
                <iframe
                    allowFullScreen={allowFullScreen}
                    css={iframeStyles}
                    // this is @deprecated but without it we still get a border
                    // eslint-disable-next-line @typescript-eslint/no-deprecated
                    frameBorder="0"
                    style={style}
                    src={src}
                    onLoad={() => {
                        setLoading(false)
                    }}
                    {...(disableScrolling
                        ? {
                              scrolling: 'no',
                          }
                        : {})}
                />
            </div>
        </div>
    )
})

export default IFrame
